import axios from 'axios';
import { utilService } from './util.service';


const chargingStrategiesService = {
    getChargingStrattegies,
    getChargingStrattegyById,
    addChargingStrategy,
    updateChargingStrategy,
    deleteChargingStrategy,
    getChargePointChargingStrategy,
    getChargePointChargingStrategyByTransaction
}

async function getChargingStrattegies() {
    return await axios.get('/ChargingStrategies');
}

async function getChargingStrattegyById(strategyId) {
    return await axios.get(`/ChargingStrategies/${strategyId}`);
}

async function getChargePointChargingStrategy(data) {
    return await axios.get(`/ChargingStrategies/GetChargePointChargingStrategy/${data}`);
}

async function getChargePointChargingStrategyByTransaction(data) {
    return await axios.get(`/ChargingStrategies/GetChargePointChargingStrategyByTransaction/${data}`);
}

async function addChargingStrategy(chargingStrategy) {
    let request = JSON.parse(JSON.stringify(chargingStrategy));
    request.chargingStrategyParts = request.chargingStrategyParts?.map(element => {
        element.startTime = utilService.validateCSharpTimeSpan(element.startTime);
        element.endTime = utilService.validateCSharpTimeSpan(element.endTime);
        return utilService.transformObjectKeys(element);
    });

    request = utilService.transformObjectKeys(request);
    return await axios.post(`/ChargingStrategies/CreateChargingStrategy`, request);
}

async function updateChargingStrategy(chargingStrategy) {
    let request = JSON.parse(JSON.stringify(chargingStrategy));
    request.chargingStrategyParts = request.chargingStrategyParts?.map(element => {
        element.startTime = utilService.validateCSharpTimeSpan(element.startTime);
        element.endTime = utilService.validateCSharpTimeSpan(element.endTime);
        return utilService.transformObjectKeys(element);
    });
    request = utilService.transformObjectKeys(request);

    return await axios.post(`/ChargingStrategies/UpdateChargingStrategy`, request);
}

async function deleteChargingStrategy(strategyId) {
    return await axios.delete(`/ChargingStrategies/DeleteChargingStrategy/${strategyId}`);
}
export default chargingStrategiesService;
